import React from 'react';
import { Hero } from '../components/Hero';
import { ShortReviews } from '../components/ShortReviews';
import { PainSection } from '../components/PainSection';
import { ProductSection } from '../components/ProductSection';
import { BonusesSection } from '../components/BonusesSection';
import { OfferSection } from '../components/OfferSection';
import { UpsellSection } from '../components/UpsellSection';
import { LongTestimonials } from '../components/LongTestimonials';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { CostSection } from '../components/CostSection';
import { ClosingSection } from '../components/ClosingSection';
import { Footer } from '../components/Footer';
export type SalesPageProps = {
  showReviews: boolean;
  showCountdown: boolean;
  showExtrasOffer: boolean;
  guaranteeEnabled: boolean;
};
export function SalesPage({
  showReviews,
  showCountdown,
  showExtrasOffer,
  guaranteeEnabled
}: SalesPageProps) {
  const offerProps = {
    showCountdown,
    showExtrasOffer,
    guaranteeEnabled
  };
  return <div className="min-h-screen w-full bg-ink font-sans text-white antialiased" data-id="element-291" data-mp="35sqazi4erf27">
      <Hero guaranteeEnabled={guaranteeEnabled} data-id="element-292" data-mp="30tnfaoabil6w" />
      <main data-id="element-293" data-mp="30ugd2zrau0cw">
        {showReviews && <ShortReviews data-id="element-294" data-mp="30rkklqy803vu" />}
        <PainSection data-id="element-295" data-mp="2vvc68frukepq" />
        <ProductSection data-id="element-296" data-mp="2vvvhjdmzs4us" />
        <BonusesSection data-id="element-297" data-mp="2vwn98ddgxifs" />
        <OfferSection variant="launch" {...offerProps} data-id="element-298" data-mp="3tikmnwczqxkv" />
        {showExtrasOffer && <UpsellSection data-id="element-299" data-mp="3tghzrl74xkkd" />}
        {showReviews && <LongTestimonials data-id="element-300" data-mp="3oizp9qdgyxa9" />}
        {guaranteeEnabled && <GuaranteeSection data-id="element-301" data-mp="3okapxhbmbox5" />}
        <FAQSection data-id="element-302" data-mp="3jkel5fv3jtgj" />
        <CostSection data-id="element-303" data-mp="3jjvdcrz5ulg8" />
        <OfferSection variant="final" {...offerProps} data-id="element-304" data-mp="3jj3jpmp4ixsl" />
        <ClosingSection data-id="element-305" data-mp="3fitbe3duzvak" />
      </main>
      <Footer data-id="element-306" data-mp="3fhrsxduik6it" />
    </div>;
}